import styled from 'styled-components';
import { ValidHex } from '@lendi-ui/commons/colours';
import { ml, pr } from '@lendi-ui/spacing';
import { Size } from '@lendi-ui/typography';

interface CardInternalsWrapperProps {
  pr?: Size;
}

export const CardInternalsWrapper = styled.div<CardInternalsWrapperProps>`
  ${(props) => props.pr && pr(props.pr)}
`;

interface ColouredCircleProps {
  backgroundColour: ValidHex;
}

export const ColouredCircle = styled.span<ColouredCircleProps>`
  width: 12px;
  height: 12px;
  ${ml('md')}
  border-radius: 50%;
  display: inline-block;
  background-color: ${({ backgroundColour }) => backgroundColour};
`;
